export default __webpack_public_path__ + "static/media/out.add4a502.png";